// Submission window — frontend mirror of the backend's authoritative
// src/shared/submissionWindow.ts (P2, match-night submission window
// widening, Lisa product ruling 2026-07-25).
//
// DUPLICATED, NOT IMPORTED: this frontend package has no import path into
// the backend's src/shared/ (separate package.json, separate tsconfig
// scoped to `frontend/src`, separate node_modules/vitest environment —
// verified, not assumed). The backend module is the SERVER-SIDE authority;
// this copy only decides what the UI DRAWS (whether to offer an upload/
// declare button at all) — the server re-checks independently on every
// write and is what actually enforces the window.
//
// KEEP THE 1-HOUR CONSTANT IN SYNC WITH THE BACKEND. If
// src/shared/submissionWindow.ts's SUBMISSION_OPEN_BEFORE_MS ever changes,
// this file's SUBMISSION_OPEN_BEFORE_MS must change with it, or the UI will
// silently offer (or hide) the upload button at the wrong time relative to
// what the server actually accepts. There is no build-time link between the
// two — this comment is the only thing standing between them.
export const SUBMISSION_OPEN_BEFORE_MS = 60 * 60 * 1000;

/**
 * Is the submission window open right now, for a slot chip's `canUpload` /
 * `canDeclare` gating?
 *
 * BYTE-IDENTICAL logic to the backend's submissionWindowOpen:
 *   - LIVE always qualifies (a card is LIVE for the whole T0..T+24h span).
 *   - SCHEDULED/VETO qualify from SUBMISSION_OPEN_BEFORE_MS (1h) before
 *     scheduledAt onward — the new pre-kickoff half of the window.
 *   - Everything else is closed.
 *   - Missing/non-numeric scheduledAt on SCHEDULED/VETO fails CLOSED — same
 *     posture as the backend, and as pokeWindowMsFor's fail-safe default.
 */
export function submissionWindowOpen(
  cardStatus: string | undefined,
  scheduledAt: number | undefined,
  now: number,
): boolean {
  if (cardStatus === 'LIVE') return true;
  if (cardStatus !== 'SCHEDULED' && cardStatus !== 'VETO') return false;
  if (typeof scheduledAt !== 'number' || !Number.isFinite(scheduledAt)) return false;
  return now >= scheduledAt - SUBMISSION_OPEN_BEFORE_MS;
}
